const $loader = $('.ajax-loader:first');

const getBlogPageTitle = function () {
	let title = document.title;
	const currentPage = parseInt($('.ren-blog__list').data('page'));
	if (WPvars) {
		if (title.includes(WPvars.translations.blog.Page)) {
			title = title.substring(
				0,
				title.lastIndexOf(WPvars.translations.blog.Page) - 1
			);
			title =
				title + ' ' + WPvars.translations.blog.Page + ' ' + currentPage;
		} else if (currentPage && currentPage > 1) {
			title =
				title +
				' | ' +
				WPvars.translations.blog.Page +
				' ' +
				currentPage;
		}
	}
	document.title = title;
	return title;
};

const getSeriesPageTitle = function (currentPageName) {
	let title = document.title;
	if (WPvars && WPvars.translations && WPvars.translations.series) {
		if (WPvars.translations.series[currentPageName]) {
			const search = '|';
			const tabTitleString = title
				.substring(title.lastIndexOf(search) + search.length)
				.trim();
			if (
				Object.values(WPvars.translations.series).some(function (k) {
					return WPvars.translations.series[k] === tabTitleString;
				})
			) {
				title = title.replace(
					tabTitleString,
					WPvars.translations.series[currentPageName]
				);
			} else {
				title =
					title + ' | ' + WPvars.translations.series[currentPageName];
			}
		}
	}
	return title;
};

export { $loader, getBlogPageTitle, getSeriesPageTitle };
